import type { ContactInput } from '@aera/schema';
import { CheckboxQuestion } from './CheckboxQuestion.js';
import { ChoiceQuestion } from './ChoiceQuestion.js';
import { CompoundQuestion } from './CompoundQuestion.js';
import { ContactQuestion } from './ContactQuestion.js';
import { RankQuestion } from './RankQuestion.js';
import { ScaleQuestion } from './ScaleQuestion.js';
import { TextQuestion } from './TextQuestion.js';
import type { AnswerProps } from './common.js';

export interface QuestionBodyProps extends AnswerProps {
  contact: ContactInput | null;
  onContact: (next: ContactInput, opts?: { debounce?: boolean }) => void;
  contactConsent: boolean;
  onContactConsent: (agree: boolean) => void;
  sessionCode: string;
}

/** Picks the renderer from the question type; nothing here knows a question id. */
export function QuestionBody(props: QuestionBodyProps) {
  const { rq } = props;
  switch (rq.type) {
    case 'single':
    case 'multi':
    case 'band':
    case 'pick_explain':
      return <ChoiceQuestion {...props} />;
    case 'scale':
      return <ScaleQuestion {...props} />;
    case 'text':
      return <TextQuestion {...props} />;
    case 'compound':
      return <CompoundQuestion {...props} />;
    case 'rank':
      return <RankQuestion {...props} />;
    case 'contact':
      return <ContactQuestion rq={rq} value={props.contact} onChange={props.onContact} sessionCode={props.sessionCode} />;
    case 'checkbox':
      return <CheckboxQuestion rq={rq} checked={props.contactConsent} onChange={props.onContactConsent} contact={props.contact} />;
  }
}
